export default [
    {
        name: 'method',
        hideLabel: true,
        component: {
            type: 'v-select',
            props: {
                label: 'Event type',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'status',
        hideLabel: true,
        component: {
            type: 'v-text-field',
            props: {
                label: 'Status',
                dense: true,
                clearable: true
            }
        }
    },
    {
        name: 'createdAtStart',
        hideLabel: true,
        component: {
            type: 'date-select',
            props: {
                label: 'Start date'
            }
        }
    },
    {
        name: 'createdAtEnd',
        hideLabel: true,
        component: {
            type: 'date-select',
            props: {
                label: 'End date'
            }
        }
    },
    {
        name: 'username',
        hideLabel: true,
        component: {
            type: 'v-text-field',
            props: {
                label: 'Username',
                dense: true,
                clearable: true
            }
        }
    }
];
